import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const LINKS = [
  { to: "/", label: "Markets" },
  { to: "/discover", label: "Discover" },
  { to: "/companies", label: "Companies" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/learn", label: "Learn" },
];

const INFO_LINKS = [
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms" },
  { to: "/contact", label: "Contact" },
];

export const Footer = () => (
  <footer data-testid="app-footer" className="relative z-10 mt-16 border-t border-white/[0.07]">
    <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/[0.14] to-transparent" />
    <div className="mx-auto max-w-[1400px] px-4 py-10 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-[1.3fr_0.8fr_0.8fr_1.1fr]">
        <div>
          <span className="font-mono text-sm font-bold tracking-[0.14em] text-white">LONGVIEW</span>
          <p className="mt-2 max-w-sm font-serif text-sm italic text-zinc-400">See the business behind the stock.</p>
          <div data-testid="footer-data-status" className="mt-4 inline-flex items-center gap-2 rounded-full border border-indigo-400/20 bg-indigo-400/[0.06] px-3 py-1.5">
            <span className="relative flex h-1.5 w-1.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-indigo-400 opacity-60" />
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-indigo-400" />
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.14em] text-indigo-200">Development Data · Yahoo Finance Sandbox</span>
          </div>
        </div>
        <div>
          <p className="kicker mb-3">Navigate</p>
          <ul className="space-y-2">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-xs text-zinc-500 transition-colors duration-200 hover:text-zinc-200">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="kicker mb-3">LONGVIEW</p>
          <ul className="space-y-2">
            {INFO_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-xs text-zinc-500 transition-colors duration-200 hover:text-zinc-200">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="kicker mb-3 flex items-center gap-1.5"><ShieldCheck className="h-3 w-3 text-amber-400" aria-hidden="true" /> Disclosure</p>
          <p className="text-[11px] leading-relaxed text-zinc-500">
            LONGVIEW provides financial information and research tools for informational and educational
            purposes and is not investment, financial, legal, or tax advice. Market prices are end-of-day,
            not real-time; source and freshness appear where available.
          </p>
          <a href="mailto:inquiry.longview@gmail.com" className="mt-3 inline-block font-mono text-[10px] text-zinc-400 transition-colors hover:text-amber-300">
            inquiry.longview@gmail.com
          </a>
        </div>
      </div>
      <div className="mt-8 flex flex-col gap-2 border-t border-white/[0.05] pt-5 text-[11px] text-zinc-600 sm:flex-row sm:items-center sm:justify-between">
        <span>© {new Date().getFullYear()} LONGVIEW. Built for Indian market education.</span>
        <span className="font-mono uppercase tracking-widest text-zinc-600">NSE · BSE · ₹ INR only</span>
      </div>
    </div>
  </footer>
);
